export const LAST_LABEL_STORAGE_KEY = 'picking_last_label_url';

/**
 * Safety-net timeout (ms) to remove the hidden print iframe if both
 * `onafterprint` and the window `focus` fallback fail to fire.
 *
 * Not the primary cleanup path: on Windows/Chromium, removing the
 * iframe while the native print dialog is open detaches the dialog
 * from its parent window and causes Windows to auto-close it. The
 * primary cleanup is event-driven (see utils/printLabel.ts).
 */
export const PRINT_IFRAME_CLEANUP_FALLBACK_MS = 5 * 60 * 1000;

/** Cart code length expected by the scanner / manual input. */
export const CART_CODE_LENGTH = 4;

/** Local print agent URL (runs on the warehouse PC). */
export const PRINT_AGENT_URL = 'http://127.0.0.1:9100';
